// extracted by mini-css-extract-plugin
export default {"StudentPhoto":"StudentPhoto_StudentPhoto__omPvp"};